<template>
  <div id="status-document">
    <b-card no-body class="py-2 container-card mb-1 bg-status-document w-100">
      <b-row class="px-1">
        <b-col cols="12" class="text-center w-100">
          <b-row class="">
            <b-col>
              <div class="d-flex justify-content-start align-items-center">
                <span
                  ><img
                    src="https://media.discordapp.net/attachments/887366626561904641/940836626152714271/Group_28079.png"
                    alt=""
                    class="image-summary mr-2"
                /></span>
                <span class="font-medium-5 font-weight text-header"
                  >Status Document</span
                >
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="w-100">
              <div
                class="
                  mt-1
                  d-flex
                  flex-wrap
                  align-items-end
                  justify-content-center
                  text-black
                  font-weight
                "
              >
                <div class="w-100">
                  <summary-bar :statusList="statusList"/>
                </div>
                <div class="d-flex justify-space-around mt-1 w-100">
                  <div class="mr-2">
                    <span>
                      <feather-icon
                        icon="CircleIcon"
                        class="mr-1 color-complete"
                    /></span>
                    <span class="font-medium-5"> {{ "Complete" }}</span>
                    <div class="font-large-1 font-color-blue">
                      {{ renderStatusComplete }}
                    </div>
                  </div>
                  <div class="mr-2">
                    <span>
                      <feather-icon
                        icon="CircleIcon"
                        class="mr-1 color-pending"
                    /></span>
                    <span class="font-medium-5"> {{ "Pending" }}</span>
                    <div class="font-large-1 font-color-blue">
                      {{ statusList.pending }}
                    </div>
                  </div>
                  <div class="mr-2">
                    <span>
                      <feather-icon icon="CircleIcon" class="mr-1 color-reject"
                    /></span>
                    <span class="font-medium-5"> {{ "Reject" }}</span>
                    <div class="font-large-1 font-color-blue">
                      {{ statusList.reject }}
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { computed, reactive, ref } from 'vue-demi';
import SummaryBar from './SummaryBar.vue';

export default {
  components: { SummaryBar },
  props: { statusData: Array, default: [] },
  setup(props) {
    const statusList = reactive({
      pending : 0,
      success : 0,
      reject : 0
    })
    const renderStatusComplete = computed(() => {
      statusList.pending = props.statusData.find(o => {
        return o.key == 1
      })?.value
      statusList.success = props.statusData.find(o => {
        return o.key == 5
      })?.value
      statusList.reject = props.statusData.find(o => {
        return o.key == 9
      })?.value
      return statusList.success
    })
    return {
      statusList,
      renderStatusComplete
    }
  },
};
</script>

<style>
</style>